import React from 'react'

const Icon = ({ iconClass, icon }) => {
  return <div className={iconClass}>{icon}</div>
}

export default Icon
